var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-items"},_vm._l((_vm.cart.items),function(item,k){return _c('CartItem',{key:_vm.getKey('cart_item', k),attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }